module.exports = __webpack_public_path__ + "media/stylesheets/resident/images/logo-2efb2f44863bd6d9ede9af2d64a4dc24.svg";